// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"2f81e353","378":"41954c01","479":"d805e82f","580":"dd8e2c03","606":"0c1cc957","617":"efb6ea4c","639":"a58325f8","846":"bc0e902c","964":"2c2c1a48"}[chunkId] + ".chunk.css";
};